module.exports = "<div class=\"pie-wrapper progress-{{vm.progress}} style-2\">\n  <span class=\"label\">\n    {{vm.value}}\n    <span class=\"smaller\">\n      {{ 'app.status.progress.' + (vm.value === 1 ? 'day' : 'days') | translate\n      }}\n    </span>\n  </span>\n  <div class=\"pie\">\n    <div class=\"left-side half-circle\"></div>\n    <div class=\"right-side half-circle\"></div>\n  </div>\n  <div class=\"shadow\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/status/components/progressPie/progressPie.html
// module id = 1774
// module chunks = 0